<template>
    <div v-if="passages_course">
        <h2 class="align_left mb-0">{{ passages_course.nom }}</h2>
        <StatutCourse :parcours="passages_course"></StatutCourse>
        <StatistiquesInscrits :parcours="passages_course"></StatistiquesInscrits>
        <h5 class="text-left mt-3">Points intermédiaires</h5>
        <div v-if="passages_course.list_points">
            <PointCourseItem v-for="point in passages_course.list_points.list" :point="point" :key="point.id">
            </PointCourseItem>
        </div>
    </div>
</template>

<script>
import StatutCourse from "@/components/Live_tab/Passages/StatutCourse.vue";
import StatistiquesInscrits from "@/components/Live_tab/Passages/StatistiquesInscrits.vue";

import PointCourseItem from "@/components/Live_tab/Passages/PointCourseItem.vue";
export default {
    components: { StatutCourse, StatistiquesInscrits, PointCourseItem },
    computed: {
        passages_course() {
            return this.$store.getters['pcCoursePassages/passages_course'];
        }
    }
}
</script>

<style lang="scss" scoped></style>